import { render, staticRenderFns } from "./form-group.vue?vue&type=template&id=26240885&scoped=true&"
import script from "./form-group.vue?vue&type=script&lang=ts&"
export * from "./form-group.vue?vue&type=script&lang=ts&"
import style0 from "./form-group.vue?vue&type=style&index=0&id=26240885&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26240885",
  null
  
)

export default component.exports